// extracted by mini-css-extract-plugin
export default {"negative":"Sum_negative__7c5uc","positive":"Sum_positive__ZpXDO","placeHolderShimmer":"Sum_placeHolderShimmer__l+wV4"};